import React from "react";

import ModalIndex from "@Modals/layout/index";

import Filter from "../Components/Filter";

export default function ModalFilterMobile(props) {
  const { onClickClose, isOpen, t, setDataFilter,filtersLists } = props;

  return (
    <ModalIndex
      isOpen={isOpen}
      onClickClose={onClickClose}
      buttonType="none"
    >
      <Filter 
          isOpen={isOpen}
          setDataFilter={setDataFilter}
          filtersLists={filtersLists}
          t={t}
          classParent="arh-w-full arh-flex arh-flex-col arh-space-y-4"
          classChild="arh-w-full arh-flex arh-flex-col arh-space-y-4"
          classSubChild="arh-w-full"
        />
    </ModalIndex>
  );
}
